<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>{{ translate("loading") }}</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid v-if="this.inSession">
        <b-row>
          <b-col md="2" style="padding:0">
            <Menu/>
          </b-col>
          <b-col md="10" style="padding:0" align="center">
            <br>
            <p v-if="bottle.name" class="w-pagetitle" style="text-align:right;margin: 2vh 10vw 0 10vw !important">
              <span v-on:click="gotoWishlist()" class="w-cursor-click" ><u>{{ translate("wishlist") }}</u></span> 
              > {{ translate("edit bottle") }}
            </p>
            <p v-else class="w-pagetitle" style="text-align:right;margin: 2vh 10vw 0 10vw !important">
              <span v-on:click="gotoWishlist()" class="w-cursor-click" ><u>{{ translate("wishlist") }}</u></span> 
              > {{ translate("new bottle") }}
            </p>            
            <div style="margin: 2vh 10vw 0 10vw !important">
              <b-row>
                <br>
                <b-tabs class="w-tabs" v-model="tabIndex" fill>
                  <div class="w-tabbox">
                    <b-tab v-if="!hideDatabase" class="w-tab" :title="translate('from database')">
                      <div v-if="bottle.wine_id == 0">
                        <LibrarySearch/>
                      </div>
                      <div v-else>
                        <BottleShow/>
                      </div>
                    </b-tab>
                    <b-tab v-if="!hideManual" class="w-tab" :title="translate('add manually')">
                      <FullDefine/>
                    </b-tab>
                  </div>
                </b-tabs>
              </b-row>
              <br>
              <b-row>
                <b-col style="text-align:left;padding:0">
                  <b-button v-on:click="onBack()" class="w-button-pink">{{ translate("back") }}</b-button>
                </b-col>
              </b-row>
              <br>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>
  </div>
</template>

<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';

  import NoAccess from './NoAccess.vue';
  import Menu from './MenuDesktop.vue';

  import LibrarySearch from './LibrarySearch_Desktop.vue';
  import FullDefine from './FullDefine_WishList_Desktop.vue';
  import BottleShow from './BottleShow_Desktop.vue';

  export default {
    name: 'BottleEdit',
    components:{
      NoAccess,
      Menu,

      LibrarySearch,
      FullDefine,
      BottleShow
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentPage() {
        return this.$store.state.current_page
      },
      previousPage() {
        return this.$store.state.previous_page
      },
      Wishlist() {
        return this.$store.state.wishlist
      },
      WishlistID() {
        return this.$store.state.wishlist_id
      },
      Bottle() {
        return this.$store.state.bottle
      },
      BottleID() {
        return this.$store.state.bottle_id
      },
      Wine() {
        return this.$store.state.wine
      },
      WineID() {
        return this.$store.state.wine_id
      },
      CWine() {
        return this.$store.state.c_wine
      },
      CWineID() {
        return this.$store.state.c_wine_id
      },
    },
    data() {
      return {
        debug: false,

        isLoading: true,
        tabIndex:0,
        hideDatabase: false,
        hideManual: false,
      }
    },
    async mounted() {
      let local_debug = false
      if (local_debug || this.debug) console.log("")
      if (local_debug || this.debug) console.log("=====> BottleEdit.mounted: START")
      // Read the STORE
      this.wishlist = this.Wishlist;
      this.wishlist_id = this.WishlistID;
      if (local_debug || this.debug) console.log("=====> BottleEdit.mounted: store read wishlist =", JSON.stringify(this.wishlist, null, 2), "wishlist_id =", this.wishlist_id);

      this.bottle = this.Bottle;
      this.bottle_id = this.BottleID;
      if (local_debug || this.debug) console.log("=====> BottleEdit.mounted: store read bottle =", JSON.stringify(this.bottle,null,2), "bottle_id =", this.bottle_id);

      if (this.bottle.c_wine_id != 0) {
        this.c_wine_id = this.bottle.c_wine_id;
        this.c_wine = this.CWine;
        this.tabIndex = 1
        this.hideDatabase = true
        if (local_debug || this.debug) console.log("=====> BottleEdit.mounted: store read c_wine =", 
          JSON.stringify(this.c_wine, (key, value) => {
            if (key === "image_files") return undefined; // skip this field
            return value;
          }, 2),
          "c_wine_id =", this.c_wine_id);
      } else if (this.bottle.wine_id != 0) {
        this.wine_id = this.bottle.wine_id;
        this.wine = this.Wine;
        this.tabIndex = 0
        this.hideManual = true
        if (local_debug || this.debug) console.log("=====> BottleEdit.mounted: store read wine =", 
          JSON.stringify(this.wine, (key, value) => {
            if (key === "image_files") return undefined; // skip this field
            return value;
          }, 2),
          "wine_id =", this.wine_id);
      } 

      if (local_debug || this.debug) console.log("=====> BottleEdit.mounted: STOP")
      this.isLoading = false;
    },
    methods: {
      onBack() {
        this.$router.push({path:'/WishList'});
      },
      gotoWishlist() {
        this.$store.commit('setPage','Wishlist')
        this.$router.push({path:'/Wishlist'});
      },
      translate(string) {
        return translate_word(string, this.currentLanguage);
      },
    }
  }
</script>
